"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9161],{

/***/ 79161:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* binding */ signInWithRedirect; }
});

// EXTERNAL MODULE: ./node_modules/@aws-amplify/core/dist/esm/singleton/Amplify.mjs + 1 modules
var Amplify = __webpack_require__(78599);
// EXTERNAL MODULE: ./node_modules/@aws-amplify/core/dist/esm/singleton/Auth/utils/index.mjs + 1 modules
var utils = __webpack_require__(33461);
;// CONCATENATED MODULE: ./node_modules/@aws-amplify/core/dist/esm/utils/urlSafeEncode.mjs
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function urlSafeEncode(str) {
    return str
        .split('')
        .map(char => char.charCodeAt(0).toString(16).padStart(2, '0'))
        .join('');
}


//# sourceMappingURL=urlSafeEncode.mjs.map

// EXTERNAL MODULE: ./node_modules/@aws-amplify/core/dist/esm/Platform/types.mjs
var types = __webpack_require__(90005);
;// CONCATENATED MODULE: ./node_modules/@aws-amplify/core/dist/esm/utils/isBrowser.mjs
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const isBrowser = () => typeof window !== 'undefined' && typeof window.document !== 'undefined';


//# sourceMappingURL=isBrowser.mjs.map

// EXTERNAL MODULE: ./node_modules/@aws-amplify/core/dist/esm/singleton/constants.mjs
var constants = __webpack_require__(35616);
// EXTERNAL MODULE: ./node_modules/@aws-amplify/auth/dist/esm/utils/getAuthUserAgentValue.mjs
var getAuthUserAgentValue = __webpack_require__(88357);
// EXTERNAL MODULE: ./node_modules/@aws-amplify/auth/dist/esm/providers/cognito/tokenProvider/tokenProvider.mjs + 4 modules
var tokenProvider = __webpack_require__(43401);
// EXTERNAL MODULE: ./node_modules/@aws-amplify/core/dist/esm/storage/index.mjs + 6 modules
var storage = __webpack_require__(31573);
// EXTERNAL MODULE: ./node_modules/@aws-amplify/auth/dist/esm/providers/cognito/utils/signInWithRedirectStore.mjs
var signInWithRedirectStore = __webpack_require__(84574);
;// CONCATENATED MODULE: ./node_modules/@aws-amplify/auth/dist/esm/providers/cognito/utils/oauth/oAuthStore.mjs



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const oAuthStore = new signInWithRedirectStore/* DefaultOAuthStore */.R(storage/* defaultStorage */.Fm);


//# sourceMappingURL=oAuthStore.mjs.map

// EXTERNAL MODULE: ./node_modules/@aws-amplify/core/dist/esm/utils/amplifyUrl/index.mjs
var amplifyUrl = __webpack_require__(96743);
// EXTERNAL MODULE: ./node_modules/@aws-amplify/core/dist/esm/constants.mjs
var esm_constants = __webpack_require__(8159);
;// CONCATENATED MODULE: ./node_modules/@aws-amplify/core/dist/esm/utils/urlSafeDecode.mjs
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
function urlSafeDecode(hex) {
    const matchArr = hex.match(/.{2}/g) || [];
    return matchArr.map(char => String.fromCharCode(parseInt(char, 16))).join('');
}


//# sourceMappingURL=urlSafeDecode.mjs.map

// EXTERNAL MODULE: ./node_modules/@aws-amplify/core/dist/esm/Hub/index.mjs
var Hub = __webpack_require__(60305);
// EXTERNAL MODULE: ./node_modules/@aws-amplify/auth/dist/esm/providers/cognito/tokenProvider/cacheTokens.mjs
var cacheTokens = __webpack_require__(14388);
// EXTERNAL MODULE: ./node_modules/@aws-amplify/auth/dist/esm/providers/cognito/utils/dispatchSignedInHubEvent.mjs
var dispatchSignedInHubEvent = __webpack_require__(89749);
// EXTERNAL MODULE: ./node_modules/@aws-amplify/core/dist/esm/Logger/ConsoleLogger.mjs + 1 modules
var ConsoleLogger = __webpack_require__(16344);
// EXTERNAL MODULE: ./node_modules/@aws-amplify/auth/dist/esm/common/AuthErrorStrings.mjs
var AuthErrorStrings = __webpack_require__(53136);
;// CONCATENATED MODULE: ./node_modules/@aws-amplify/auth/dist/esm/Errors.mjs



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// TODO: delete this module when the Auth class is removed.
const logger = new ConsoleLogger/* ConsoleLogger */.k('AuthError');
class AuthError extends Error {
    constructor(type) {
        const { message, log } = authErrorMessages[type];
        super(message);
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = AuthError;
        Object.setPrototypeOf(this, AuthError.prototype);
        this.name = 'AuthError';
        this.log = log || message;
        logger.error(this.log);
    }
}
class NoUserPoolError extends (/* unused pure expression or super */ null && (AuthError)) {
    constructor(type) {
        super(type);
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        this.constructor = NoUserPoolError;
        Object.setPrototypeOf(this, NoUserPoolError.prototype);
        this.name = 'NoUserPoolError';
    }
}
const authErrorMessages = {
    oauthSignInError: {
        message: AuthErrorStrings/* AuthErrorStrings.OAUTH_ERROR */.AL.OAUTH_ERROR,
        log: 'Make sure Cognito Hosted UI has been configured correctly',
    },
    noConfig: {
        message: AuthErrorStrings/* AuthErrorStrings.DEFAULT_MSG */.AL.DEFAULT_MSG,
        log: `
            Error: Amplify has not been configured correctly.
            This error is typically caused by one of the following scenarios:

            1. Make sure you're passing the awsconfig object to Amplify.configure() in your app's entry point
                See https://aws-amplify.github.io/docs/js/authentication#configure-your-app for more information
            
            2. There might be multiple conflicting versions of amplify packages in your node_modules.
				Refer to our docs site for help upgrading Amplify packages (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js)
        `,
    },
    missingAuthConfig: {
        message: AuthErrorStrings/* AuthErrorStrings.DEFAULT_MSG */.AL.DEFAULT_MSG,
        log: `
            Error: Amplify has not been configured correctly. 
            The configuration object is missing required auth properties.
            This error is typically caused by one of the following scenarios:

            1. Did you run \`amplify push\` after adding auth via \`amplify add auth\`?
                See https://aws-amplify.github.io/docs/js/authentication#amplify-project-setup for more information

            2. This could also be caused by multiple conflicting versions of amplify packages, see (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js) for help upgrading Amplify packages.
        `,
    },
    emptyUsername: {
        message: AuthErrorStrings/* AuthErrorStrings.EMPTY_USERNAME */.AL.EMPTY_USERNAME,
    },
    // TODO: should include a list of valid sign-in types
    invalidUsername: {
        message: AuthErrorStrings/* AuthErrorStrings.INVALID_USERNAME */.AL.INVALID_USERNAME,
    },
    emptyPassword: {
        message: AuthErrorStrings/* AuthErrorStrings.EMPTY_PASSWORD */.AL.EMPTY_PASSWORD,
    },
    emptyCode: {
        message: AuthErrorStrings/* AuthErrorStrings.EMPTY_CODE */.AL.EMPTY_CODE,
    },
    signUpError: {
        message: AuthErrorStrings/* AuthErrorStrings.SIGN_UP_ERROR */.AL.SIGN_UP_ERROR,
        log: 'The first parameter should either be non-null string or object',
    },
    noMFA: {
        message: AuthErrorStrings/* AuthErrorStrings.NO_MFA */.AL.NO_MFA,
    },
    invalidMFA: {
        message: AuthErrorStrings/* AuthErrorStrings.INVALID_MFA */.AL.INVALID_MFA,
    },
    emptyChallengeResponse: {
        message: AuthErrorStrings/* AuthErrorStrings.EMPTY_CHALLENGE */.AL.EMPTY_CHALLENGE,
    },
    noUserSession: {
        message: AuthErrorStrings/* AuthErrorStrings.NO_USER_SESSION */.AL.NO_USER_SESSION,
    },
    deviceConfig: {
        message: AuthErrorStrings/* AuthErrorStrings.DEVICE_CONFIG */.AL.DEVICE_CONFIG,
    },
    networkError: {
        message: AuthErrorStrings/* AuthErrorStrings.NETWORK_ERROR */.AL.NETWORK_ERROR,
    },
    autoSignInError: {
        message: AuthErrorStrings/* AuthErrorStrings.AUTOSIGNIN_ERROR */.AL.AUTOSIGNIN_ERROR,
    },
    default: {
        message: AuthErrorStrings/* AuthErrorStrings.DEFAULT_MSG */.AL.DEFAULT_MSG,
    },
};


//# sourceMappingURL=Errors.mjs.map

// EXTERNAL MODULE: ./node_modules/@aws-amplify/auth/dist/esm/errors/AuthError.mjs
var errors_AuthError = __webpack_require__(74686);
;// CONCATENATED MODULE: ./node_modules/@aws-amplify/auth/dist/esm/providers/cognito/utils/oauth/createOAuthError.mjs




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const createOAuthError = (message, recoverySuggestion) => new errors_AuthError/* AuthError */.l({
    message: message ?? 'An error has occurred during the oauth process.',
    name: AuthErrorStrings/* AuthErrorCodes.OAuthSignInError */.kq.OAuthSignInError,
    recoverySuggestion: recoverySuggestion ?? authErrorMessages.oauthSignInError.log,
});


//# sourceMappingURL=createOAuthError.mjs.map

;// CONCATENATED MODULE: ./node_modules/@aws-amplify/auth/dist/esm/providers/cognito/utils/oauth/inflightPromise.mjs
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const inflightPromises = [];
const addInflightPromise = (resolver) => {
    inflightPromises.push(resolver);
};
const resolveAndClearInflightPromises = () => {
    while (inflightPromises.length) {
        inflightPromises.pop()?.();
    }
};


//# sourceMappingURL=inflightPromise.mjs.map

;// CONCATENATED MODULE: ./node_modules/@aws-amplify/auth/dist/esm/types/Auth.mjs
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var AuthErrorTypes;
(function (AuthErrorTypes) {
    AuthErrorTypes["NoConfig"] = "noConfig";
    AuthErrorTypes["MissingAuthConfig"] = "missingAuthConfig";
    AuthErrorTypes["EmptyUsername"] = "emptyUsername";
    AuthErrorTypes["InvalidUsername"] = "invalidUsername";
    AuthErrorTypes["EmptyPassword"] = "emptyPassword";
    AuthErrorTypes["EmptyCode"] = "emptyCode";
    AuthErrorTypes["SignUpError"] = "signUpError";
    AuthErrorTypes["NoMFA"] = "noMFA";
    AuthErrorTypes["InvalidMFA"] = "invalidMFA";
    AuthErrorTypes["EmptyChallengeResponse"] = "emptyChallengeResponse";
    AuthErrorTypes["NoUserSession"] = "noUserSession";
    AuthErrorTypes["Default"] = "default";
    AuthErrorTypes["DeviceConfig"] = "deviceConfig";
    AuthErrorTypes["NetworkError"] = "networkError";
    AuthErrorTypes["AutoSignInError"] = "autoSignInError";
    AuthErrorTypes["OAuthSignInError"] = "oauthSignInError";
})(AuthErrorTypes || (AuthErrorTypes = {}));


//# sourceMappingURL=Auth.mjs.map

;// CONCATENATED MODULE: ./node_modules/@aws-amplify/auth/dist/esm/providers/cognito/utils/oauth/validateState.mjs




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const flowCancelledMessage = '`signInWithRedirect` has been canceled.';
const validationFailedMessage = 'An error occurred while validating the state.';
const validationRecoverySuggestion = 'Try to initiate an OAuth flow from Amplify';
const validateState = async (state) => {
    const savedState = await oAuthStore.loadOAuthState();
    // This is because savedState only exists if the flow was initiated by Amplify
    const validatedState = state === savedState ? savedState : undefined;
    if (!validatedState) {
        throw new errors_AuthError/* AuthError */.l({
            name: AuthErrorTypes.OAuthSignInError,
            message: state === null ? flowCancelledMessage : validationFailedMessage,
            recoverySuggestion: state === null ? undefined : validationRecoverySuggestion,
        });
    }
    return validatedState;
};


//# sourceMappingURL=validateState.mjs.map

;// CONCATENATED MODULE: ./node_modules/@aws-amplify/auth/dist/esm/providers/cognito/utils/oauth/completeOAuthFlow.mjs












// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const completeOAuthFlow = async ({ currentUrl, userAgentValue, clientId, redirectUri, responseType, domain, preferPrivateSession, }) => {
    const urlParams = new amplifyUrl/* AmplifyUrl */.a(currentUrl);
    const error = urlParams.searchParams.get('error');
    const errorMessage = urlParams.searchParams.get('error_description');
    if (error) {
        throw createOAuthError(errorMessage ?? error);
    }
    if (responseType === 'code') {
        return handleCodeFlow({
            currentUrl,
            userAgentValue,
            clientId,
            redirectUri,
            domain,
            preferPrivateSession,
        });
    }
    return handleImplicitFlow({
        currentUrl,
        redirectUri,
        preferPrivateSession,
    });
};
const handleCodeFlow = async ({ currentUrl, userAgentValue, clientId, redirectUri, domain, preferPrivateSession, }) => {
    /* Convert URL into an object with parameters as keys
{ redirect_uri: 'http://localhost:3000/', response_type: 'code', ...} */
    const url = new amplifyUrl/* AmplifyUrl */.a(currentUrl);
    const code = url.searchParams.get('code');
    const state = url.searchParams.get('state');
    // if `code` or `state` is not presented in the redirect url, most likely
    // that the end user cancelled the inflight oauth flow by:
    // 1. clicking the back button of browser
    // 2. closing the provider hosted UI page and coming back to the app
    if (!code || !state) {
        throw createOAuthError('User cancelled OAuth flow.');
    }
    // may throw error is being caught in attemptCompleteOAuthFlow.ts
    const validatedState = await validateState(state);
    const oAuthTokenEndpoint = 'https://' + domain + '/oauth2/token';
    // TODO(v6): check hub events
    // dispatchAuthEvent(
    // 	'codeFlow',
    // 	{},
    // 	`Retrieving tokens from ${oAuthTokenEndpoint}`
    // );
    const codeVerifier = await oAuthStore.loadPKCE();
    const oAuthTokenBody = {
        grant_type: 'authorization_code',
        code,
        client_id: clientId,
        redirect_uri: redirectUri,
        ...(codeVerifier ? { code_verifier: codeVerifier } : {}),
    };
    const body = Object.entries(oAuthTokenBody)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
    const { access_token, refresh_token: refreshToken, id_token, error, error_message: errorMessage, token_type, expires_in, } = await (await fetch(oAuthTokenEndpoint, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            [esm_constants/* USER_AGENT_HEADER */.Mt]: userAgentValue,
        },
        body,
    })).json();
    if (error) {
        // error is being caught in attemptCompleteOAuthFlow.ts
        throw createOAuthError(errorMessage ?? error);
    }
    const username = (access_token && (0,utils/* decodeJWT */.xp)(access_token).payload.username) ?? 'username';
    await (0,cacheTokens/* cacheCognitoTokens */.x)({
        username,
        AccessToken: access_token,
        IdToken: id_token,
        RefreshToken: refreshToken,
        TokenType: token_type,
        ExpiresIn: expires_in,
    });
    return completeFlow({
        redirectUri,
        state: validatedState,
        preferPrivateSession,
    });
};
const handleImplicitFlow = async ({ currentUrl, redirectUri, preferPrivateSession, }) => {
    // hash is `null` if `#` doesn't exist on URL
    const url = new amplifyUrl/* AmplifyUrl */.a(currentUrl);
    const { id_token, access_token, state, token_type, expires_in, error_description, error, } = (url.hash ?? '#')
        .substring(1) // Remove # from returned code
        .split('&')
        .map(pairings => pairings.split('='))
        .reduce((accum, [k, v]) => ({ ...accum, [k]: v }), {
        id_token: undefined,
        access_token: undefined,
        state: undefined,
        token_type: undefined,
        expires_in: undefined,
        error_description: undefined,
        error: undefined,
    });
    if (error) {
        throw createOAuthError(error_description ?? error);
    }
    if (!access_token) {
        // error is being caught in attemptCompleteOAuthFlow.ts
        throw createOAuthError('No access token returned from OAuth flow.');
    }
    const validatedState = await validateState(state);
    const username = (access_token && (0,utils/* decodeJWT */.xp)(access_token).payload.username) ?? 'username';
    await (0,cacheTokens/* cacheCognitoTokens */.x)({
        username,
        AccessToken: access_token,
        IdToken: id_token,
        TokenType: token_type,
        ExpiresIn: expires_in,
    });
    return completeFlow({
        redirectUri,
        state: validatedState,
        preferPrivateSession,
    });
};
const completeFlow = async ({ redirectUri, state, preferPrivateSession, }) => {
    await oAuthStore.clearOAuthData();
    await oAuthStore.storeOAuthSignIn(true, preferPrivateSession);
    // this should be called before any call that involves `fetchAuthSession`
    // e.g. `getCurrentUser()` below, so it allows every inflight async calls to
    //  `fetchAuthSession` can be resolved
    resolveAndClearInflightPromises();
    // when the oauth flow is completed, there should be nothing to block the async calls
    // that involves fetchAuthSession in the `TokenOrchestrator`
    tokenProvider/* cognitoUserPoolsTokenProvider.setWaitForInflightOAuth */.D.setWaitForInflightOAuth(async () => {
        // no-op
    });
    if (isCustomState(state)) {
        Hub/* Hub.dispatch */.Xb.dispatch('auth', {
            event: 'customOAuthState',
            data: urlSafeDecode(getCustomState(state)),
        }, 'Auth', Hub/* AMPLIFY_SYMBOL */.SQ);
    }
    Hub/* Hub.dispatch */.Xb.dispatch('auth', { event: 'signInWithRedirect' }, 'Auth', Hub/* AMPLIFY_SYMBOL */.SQ);
    await (0,dispatchSignedInHubEvent/* dispatchSignedInHubEvent */.O)();
    clearHistory(redirectUri);
};
const isCustomState = (state) => {
    return /-/.test(state);
};
const getCustomState = (state) => {
    return state.split('-').splice(1).join('-');
};
const clearHistory = (redirectUri) => {
    if (typeof window !== 'undefined' && typeof window.history !== 'undefined') {
        window.history.replaceState(window.history.state, '', redirectUri);
    }
};


//# sourceMappingURL=completeOAuthFlow.mjs.map

// EXTERNAL MODULE: ./node_modules/@aws-amplify/auth/dist/esm/providers/cognito/utils/oauth/getRedirectUrl.mjs
var getRedirectUrl = __webpack_require__(60739);
;// CONCATENATED MODULE: ./node_modules/@aws-amplify/auth/dist/esm/providers/cognito/utils/oauth/handleFailure.mjs





// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const handleFailure = async (error) => {
    resolveAndClearInflightPromises();
    await oAuthStore.clearOAuthInflightData();
    Hub/* Hub.dispatch */.Xb.dispatch('auth', { event: 'signInWithRedirect_failure', data: { error } }, 'Auth', Hub/* AMPLIFY_SYMBOL */.SQ);
};


//# sourceMappingURL=handleFailure.mjs.map

;// CONCATENATED MODULE: ./node_modules/@aws-amplify/auth/dist/esm/providers/cognito/utils/oauth/attemptCompleteOAuthFlow.mjs












// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const attemptCompleteOAuthFlow = async (authConfig) => {
    try {
        (0,utils/* assertTokenProviderConfig */.FG)(authConfig);
        (0,utils/* assertOAuthConfig */.V0)(authConfig);
        oAuthStore.setAuthConfig(authConfig);
    }
    catch (_) {
        // no-op
        // This should not happen as Amplify singleton checks the oauth config key
        // unless the oauth config object doesn't contain required properties
        return;
    }
    // No inflight OAuth
    if (!(await oAuthStore.loadOAuthInFlight())) {
        return;
    }
    // when there is valid oauth config and there is an inflight oauth flow, try
    // to block async calls that require fetching tokens before the oauth flow completes
    // e.g. getCurrentUser, fetchAuthSession etc.
    const asyncGetSessionBlocker = new Promise((resolve, _reject) => {
        addInflightPromise(resolve);
    });
    tokenProvider/* cognitoUserPoolsTokenProvider.setWaitForInflightOAuth */.D.setWaitForInflightOAuth(() => asyncGetSessionBlocker);
    try {
        const currentUrl = window.location.href;
        const { loginWith, userPoolClientId } = authConfig;
        const { domain, redirectSignIn, responseType } = loginWith.oauth;
        const redirectUri = (0,getRedirectUrl/* getRedirectUrl */.B)(redirectSignIn);
        await completeOAuthFlow({
            currentUrl,
            clientId: userPoolClientId,
            domain,
            redirectUri,
            responseType,
            userAgentValue: (0,getAuthUserAgentValue/* getAuthUserAgentValue */.W)(types/* AuthAction.SignInWithRedirect */.g4.SignInWithRedirect),
        });
    }
    catch (err) {
        await handleFailure(err);
    }
};


//# sourceMappingURL=attemptCompleteOAuthFlow.mjs.map

;// CONCATENATED MODULE: ./node_modules/@aws-amplify/auth/dist/esm/providers/cognito/utils/oauth/enableOAuthListener.mjs




// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// attach the side effect for handling the completion of an inflight oauth flow
// this side effect works only on Web
isBrowser() &&
    (() => {
        // add the listener to the singleton for triggering
        Amplify/* Amplify */.d[constants/* ADD_OAUTH_LISTENER */.w](attemptCompleteOAuthFlow);
    })();
//# sourceMappingURL=enableOAuthListener.mjs.map

;// CONCATENATED MODULE: ./node_modules/@aws-amplify/auth/dist/esm/providers/cognito/types/models.mjs
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const cognitoHostedUIIdentityProviderMap = {
    Google: 'Google',
    Facebook: 'Facebook',
    Amazon: 'LoginWithAmazon',
    Apple: 'SignInWithApple',
};


//# sourceMappingURL=models.mjs.map

// EXTERNAL MODULE: ./node_modules/@aws-amplify/auth/dist/esm/utils/openAuthSession.mjs
var openAuthSession = __webpack_require__(92535);
// EXTERNAL MODULE: ./node_modules/@aws-amplify/auth/dist/esm/providers/cognito/utils/signInHelpers.mjs + 21 modules
var signInHelpers = __webpack_require__(50346);
// EXTERNAL MODULE: ./node_modules/@aws-crypto/sha256-js/build/module/index.js + 7 modules
var build_module = __webpack_require__(50188);
// EXTERNAL MODULE: ./node_modules/@aws-amplify/core/dist/esm/utils/globalHelpers/index.mjs
var globalHelpers = __webpack_require__(4477);
// EXTERNAL MODULE: ./node_modules/@aws-amplify/core/dist/esm/utils/convert/base64/base64Encoder.mjs + 1 modules
var base64Encoder = __webpack_require__(91698);
;// CONCATENATED MODULE: ./node_modules/@aws-amplify/auth/dist/esm/providers/cognito/utils/oauth/generateCodeVerifier.mjs



// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const CODE_VERIFIER_CHARSET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
/**
 *
 * @param length Desired length of the code verifier.
 *
 * **NOTE:** According to the [RFC 7636](https://datatracker.ietf.org/doc/html/rfc7636#section-4.1)
 * A code verifier must be with a length >= 43 and <= 128.
 *
 * @returns An object that contains the generated `codeVerifier` and a method
 * `toCodeChallenge` to generate the code challenge from the `codeVerifier`
 * following the spec of [RFC 7636](https://datatracker.ietf.org/doc/html/rfc7636#section-4.2).
 */
const generateCodeVerifier = (length) => {
    const randomBytes = new Uint8Array(length);
    (0,globalHelpers/* getCrypto */.MX)().getRandomValues(randomBytes);
    let value = '';
    let codeChallenge;
    for (const byte of randomBytes) {
        value += CODE_VERIFIER_CHARSET.charAt(byte % CODE_VERIFIER_CHARSET.length);
    }
    return {
        value,
        method: 'S256',
        toCodeChallenge() {
            if (codeChallenge) {
                return codeChallenge;
            }
            codeChallenge = generateCodeChallenge(value);
            return codeChallenge;
        },
    };
};
function generateCodeChallenge(codeVerifier) {
    const awsCryptoHash = new build_module/* Sha256 */.f();
    awsCryptoHash.update(codeVerifier);
    const codeChallenge = removePaddingChar(base64Encoder/* base64Encoder.convert */.u.convert(awsCryptoHash.digestSync(), { urlSafe: true }));
    return codeChallenge;
}
function removePaddingChar(base64Encoded) {
    return base64Encoded.replace(/=/g, '');
}


//# sourceMappingURL=generateCodeVerifier.mjs.map

;// CONCATENATED MODULE: ./node_modules/@aws-amplify/core/dist/esm/utils/generateRandomString.mjs
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const generateRandomString = (length) => {
    const STATE_CHARSET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
        result += STATE_CHARSET.charAt(Math.floor(Math.random() * STATE_CHARSET.length));
    }
    return result;
};


//# sourceMappingURL=generateRandomString.mjs.map

;// CONCATENATED MODULE: ./node_modules/@aws-amplify/auth/dist/esm/providers/cognito/utils/oauth/generateState.mjs


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const generateState = () => {
    return generateRandomString(32);
};


//# sourceMappingURL=generateState.mjs.map

;// CONCATENATED MODULE: ./node_modules/@aws-amplify/auth/dist/esm/providers/cognito/apis/signInWithRedirect.mjs


















// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Signs in a user with OAuth. Redirects the application to an Identity Provider.
 *
 * @param input - The SignInWithRedirectInput object, if empty it will redirect to Cognito HostedUI
 *
 * @throws AuthTokenConfigException - Thrown when the user pool config is invalid.
 * @throws OAuthNotConfigureException - Thrown when the oauth config is invalid.
 */
async function signInWithRedirect(input) {
    const authConfig = Amplify/* Amplify.getConfig */.d.getConfig().Auth?.Cognito;
    (0,utils/* assertTokenProviderConfig */.FG)(authConfig);
    (0,utils/* assertOAuthConfig */.V0)(authConfig);
    oAuthStore.setAuthConfig(authConfig);
    await (0,signInHelpers/* assertUserNotAuthenticated */.OP)();
    let provider = 'COGNITO'; // Default
    if (typeof input?.provider === 'string') {
        provider = cognitoHostedUIIdentityProviderMap[input.provider];
    }
    else if (input?.provider?.custom) {
        provider = input.provider.custom;
    }
    return oauthSignIn({
        oauthConfig: authConfig.loginWith.oauth,
        clientId: authConfig.userPoolClientId,
        provider,
        customState: input?.customState,
        preferPrivateSession: input?.options?.preferPrivateSession,
    });
}
const oauthSignIn = async ({ oauthConfig, provider, clientId, customState, preferPrivateSession, }) => {
    const { domain, redirectSignIn, responseType, scopes } = oauthConfig;
    const randomState = generateState();
    /* encodeURIComponent is not URL safe, use urlSafeEncode instead. Cognito
    single-encodes/decodes url on first sign in and double-encodes/decodes url
    when user already signed in. Using encodeURIComponent, Base32, Base64 add
    characters % or = which on further encoding becomes unsafe. '=' create issue
    for parsing query params.
    Refer: https://github.com/aws-amplify/amplify-js/issues/5218 */
    const state = customState
        ? `${randomState}-${urlSafeEncode(customState)}`
        : randomState;
    const { value, method, toCodeChallenge } = generateCodeVerifier(128);
    const redirectUri = (0,getRedirectUrl/* getRedirectUrl */.B)(oauthConfig.redirectSignIn);
    oAuthStore.storeOAuthInFlight(true);
    oAuthStore.storeOAuthState(state);
    oAuthStore.storePKCE(value);
    const queryString = Object.entries({
        redirect_uri: redirectUri,
        response_type: responseType,
        client_id: clientId,
        identity_provider: provider,
        scope: scopes.join(' '),
        state,
        ...(responseType === 'code' && {
            code_challenge: toCodeChallenge(),
            code_challenge_method: method,
        }),
    })
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
    // TODO(v6): use URL object instead
    const oAuthUrl = `https://${domain}/oauth2/authorize?${queryString}`;
    // the following is effective only in react-native as openAuthSession resolves only in react-native
    const { type, error, url } = (await (0,openAuthSession/* openAuthSession */.A)(oAuthUrl)) ??
        {};
    try {
        if (type === 'error') {
            throw createOAuthError(String(error));
        }
        if (type === 'success' && url) {
            await completeOAuthFlow({
                currentUrl: url,
                clientId,
                domain,
                redirectUri,
                responseType,
                userAgentValue: (0,getAuthUserAgentValue/* getAuthUserAgentValue */.W)(types/* AuthAction.SignInWithRedirect */.g4.SignInWithRedirect),
                preferPrivateSession,
            });
        }
    }
    catch (err) {
        await handleFailure(err);
        // rethrow the error so it can be caught by `await signInWithRedirect()` in react-native
        throw err;
    }
};


//# sourceMappingURL=signInWithRedirect.mjs.map


/***/ })

}]);